module.exports = __webpack_public_path__ + "static/img/bulk-create@2x.1647dfa0.png";